import { z } from 'zod';
import { IdListQuery } from '../../profile.js';
import { ContentBase } from '../../content.js';
import { CursorQuery, Paginated } from '../../common/pagination.js';
import { ReactionState, SetReactionInput, ViewerContentState } from '../../engagement-routes.js';
import { CommentLikeState, CommentView, CreateCommentInput } from '../../comments.js';
import { FavouriteState } from '../../content-mutations.js';
export const engagementRoutes = {
    viewerState: {
        method: 'GET',
        path: '/content/viewer-state',
        query: IdListQuery,
        response: z.array(ViewerContentState),
    },
    react: {
        method: 'POST',
        path: '/content/:contentId/reactions',
        body: SetReactionInput,
        response: ReactionState,
    },
    commentCreate: {
        method: 'POST',
        path: '/content/:contentId/comments',
        body: CreateCommentInput,
        response: CommentView,
    },
    commentList: {
        method: 'GET',
        path: '/content/:contentId/comments',
        query: CursorQuery,
        response: Paginated(CommentView),
    },
    opvCreate: {
        method: 'POST',
        path: '/content/:contentId/opvs',
        body: CreateCommentInput,
        response: CommentView,
    },
    opvList: {
        method: 'GET',
        path: '/content/:contentId/opvs',
        query: CursorQuery,
        response: Paginated(CommentView),
    },
    replyList: {
        method: 'GET',
        path: '/comments/:commentId/replies',
        query: CursorQuery,
        response: Paginated(CommentView),
    },
    commentLike: {
        method: 'POST',
        path: '/comments/:commentId/likes',
        response: CommentLikeState,
    },
    favourite: {
        method: 'POST',
        path: '/content/:contentId/favourites',
        response: FavouriteState,
    },
    myFavourites: {
        method: 'GET',
        path: '/me/favourites',
        query: CursorQuery,
        response: Paginated(ContentBase),
    },
};
//# sourceMappingURL=routes.js.map